import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const FlashlightAnimation = () => {
  const [lightAngle, setLightAngle] = useState(0);

  // Bills scattered around the scene with positions (percentage based)
  const bills = [
    { id: 1, x: 15, y: 20, rotation: -15 },
    { id: 2, x: 75, y: 25, rotation: 10 },
    { id: 3, x: 30, y: 45, rotation: 5 },
    { id: 4, x: 60, y: 35, rotation: -8 },
    { id: 5, x: 45, y: 15, rotation: 12 },
    { id: 6, x: 85, y: 50, rotation: -20 },
    { id: 7, x: 10, y: 55, rotation: 8 },
  ];

  // Sweep the flashlight left to right continuously (slower)
  useEffect(() => {
    const interval = setInterval(() => {
      setLightAngle(prev => {
        // Sweep from -35 to 35 degrees and back
        const newAngle = prev + 1.2;
        if (newAngle > 70) return 0;
        return newAngle;
      });
    }, 80);

    return () => clearInterval(interval);
  }, []);

  // Calculate if a bill is within the flashlight cone
  const isIlluminated = (billX) => {
    // Light source is at bottom center (50%)
    // Convert angle to approximate x position coverage
    const sweepAngle = lightAngle - 35; // -35 to +35
    const lightCenterX = 50 + sweepAngle * 1.2; // Maps to roughly 8-92% of width
    const coneWidth = 25; // Width of illumination cone
    
    return Math.abs(billX - lightCenterX) < coneWidth;
  };

  const sweepAngle = lightAngle - 35;

  return (
    <div className="w-full aspect-video bg-background-light rounded-2xl border-4 border-black overflow-hidden relative">
      
      {/* Flashlight cone */}
      <motion.div
        className="absolute bottom-0 left-1/2 origin-bottom"
        style={{
          width: '200px',
          height: '300px',
          marginLeft: '-100px',
          background: 'conic-gradient(from -15deg at 50% 100%, transparent 0deg, rgba(255, 220, 100, 0.4) 15deg, rgba(255, 220, 100, 0.2) 30deg, transparent 30deg)',
          filter: 'blur(8px)',
        }}
        animate={{
          rotate: sweepAngle,
        }}
        transition={{
          duration: 0.08,
          ease: "linear"
        }}
      />

      {/* Brighter inner cone */}
      <motion.div
        className="absolute bottom-0 left-1/2 origin-bottom"
        style={{
          width: '150px',
          height: '280px',
          marginLeft: '-75px',
          background: 'conic-gradient(from -10deg at 50% 100%, transparent 0deg, rgba(255, 230, 150, 0.5) 10deg, rgba(255, 230, 150, 0.25) 20deg, transparent 20deg)',
          filter: 'blur(4px)',
        }}
        animate={{
          rotate: sweepAngle,
        }}
        transition={{
          duration: 0.08,
          ease: "linear"
        }}
      />

      {/* Bills */}
      {bills.map((bill) => {
        const illuminated = isIlluminated(bill.x);
        
        return (
          <motion.div
            key={bill.id}
            className="absolute flex items-center justify-center"
            style={{
              left: `${bill.x}%`,
              top: `${bill.y}%`,
              transform: `translate(-50%, -50%) rotate(${bill.rotation}deg)`,
            }}
          >
            <motion.span
              className="text-4xl"
              animate={{
                filter: illuminated ? 'grayscale(0%) brightness(1)' : 'grayscale(100%) brightness(0.3)',
                scale: illuminated ? 1.15 : 1,
              }}
              transition={{
                duration: 0.3,
              }}
            >
              💵
            </motion.span>
          </motion.div>
        );
      })}

      {/* Flashlight emoji at bottom */}
      <motion.div
        className="absolute bottom-2 left-1/2 origin-bottom z-20"
        style={{ marginLeft: '-20px' }}
        animate={{
          rotate: sweepAngle * 0.5,
        }}
        transition={{
          duration: 0.08,
          ease: "linear"
        }}
      >
        <span className="text-4xl" style={{ transform: 'scaleY(-1)', display: 'inline-block' }}>🔦</span>
      </motion.div>

      {/* Label */}
      <div className="absolute bottom-2 right-3 text-xs font-bold text-gray-500">
        מחפשים את המזומן...
      </div>
    </div>
  );
};

export default FlashlightAnimation;
